@if (lesson | async; as lesson) {
  @if (lessonPerformance | async; as lessonPerformance) {
    <section class="col-8 mx-auto text-center">
      <header>
        <h1>{{lesson.completeHeadline}}</h1>
        <p class="lead">{{lesson.completeCopy}}</p>
      </header>
      <div class="jumbotron">
        <div class="row">
          <div class="col-6">
            <h3 class="display-3">{{lessonPerformance.percentCorrect.toFixed() + '%'}}</h3>
            <h4>
              Accuracy<br>
              <i class="fa fa-bullseye"></i>
            </h4>
          </div>
          <div class="col-6">
            <h3 class="display-3">{{lessonPerformance.secondsPerQuestion | time}}</h3>
            <h4>
              Per Question<br>
              <i class="fa fa-stopwatch"></i>
            </h4>
          </div>
        </div>
      </div>
      <aside>
        @if (lessonPerformance.smartSaverEarned) {
          <div class="col-8 mx-auto">
            <div class="row">
              <div class="col-6">
                <h3><i class="fa fa-life-saver"></i> Smartsavers Earned</h3>
              </div>
              <div class="col-6">
                <ul class="list-unstyled list-inline pull-right">
                  <li class="list-inline-item">
                    #{{lessonPerformance.smartSaverEarned.getHint || 0 }}
                    <button class="btn btn-primary btn-sm" placement="bottom" ngbTooltip="Get Hint">
                      <i class="fa fa-puzzle-piece"></i>
                    </button>
                  </li>
                  <li class="list-inline-item">
                    #{{lessonPerformance.smartSaverEarned.cutIncorrect || 0}}
                    <button class="btn btn-primary btn-sm" placement="bottom" ngbTooltip="Cut Incorrect">
                      <i class="fa fa-scissors"></i>
                    </button>
                  </li>
                  <li class="list-inline-item">
                    #{{lessonPerformance.smartSaverEarned.stopTimer || 0}}
                    <button class="btn btn-primary btn-sm" placement="bottom" ngbTooltip="Stop timer">
                      <i class="fa fa-clock-o"></i>
                    </button>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        }
      </aside>
      <a class="btn btn-primary btn-lg" [routerLink]="['/../../../']">Return To Dashboard</a>
    </section>
  } @else {
    <app-spinner></app-spinner>
  }
} @else {
  <app-spinner></app-spinner>
}

